
import { useState } from 'react';

export default function TestimonialsSection() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      name: "Maria Rodriguez",
      text: "Blue Team did an amazing job cleaning our carpets! They were professional, on time, and the results were incredible. Our carpets look brand new. Highly recommend their services in Escondido!",
      rating: 5,
      timeAgo: "2 weeks ago",
      avatar: "https://www.canadacleanhome.com/wp-content/plugins/business-reviews-bundle/assets/img/google_avatar.png"
    },
    {
      name: "John Mitchell",
      text: "Excellent carpet cleaning service! The team was very thorough and got out stains I thought were permanent. Great value for the price and they serve the entire San Diego area. Will definitely use again.",
      rating: 5,
      timeAgo: "3 weeks ago",
      avatar: "https://www.canadacleanhome.com/wp-content/plugins/business-reviews-bundle/assets/img/google_avatar.png"
    },
    {
      name: "Sarah Thompson",
      text: "Blue Team cleaned both our carpets and dryer vent. Professional service from start to finish. They explained everything they were doing and the results exceeded our expectations. Highly recommended!",
      rating: 5,
      timeAgo: "1 month ago",
      avatar: "https://www.canadacleanhome.com/wp-content/plugins/business-reviews-bundle/assets/img/google_avatar.png"
    },
    {
      name: "David Chen",
      text: "Outstanding carpet cleaning service! They removed pet stains and odors that other companies couldn't handle. The truck-mounted equipment really makes a difference. Blue Team is the best in Escondido!",
      rating: 5,
      timeAgo: "1 month ago",
      avatar: "https://www.canadacleanhome.com/wp-content/plugins/business-reviews-bundle/assets/img/google_avatar.png"
    },
    {
      name: "Jennifer Williams",
      text: "Very impressed with Blue Team's professionalism and quality of work. They cleaned our office carpets and furniture. Everything looks fantastic and dried quickly. Great customer service too!",
      rating: 5,
      timeAgo: "2 months ago",
      avatar: "https://www.canadacleanhome.com/wp-content/plugins/business-reviews-bundle/assets/img/google_avatar.png"
    },
    {
      name: "Robert Garcia",
      text: "Blue Team has been cleaning our carpets for years. Always reliable, always professional, and always delivers excellent results. They're our go-to for carpet and upholstery cleaning in San Diego County.",
      rating: 5,
      timeAgo: "2 months ago",
      avatar: "https://www.canadacleanhome.com/wp-content/plugins/business-reviews-bundle/assets/img/google_avatar.png"
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">What Our Customers Say</h2>
          <p className="text-xl text-gray-600">Real reviews from satisfied Blue Team customers across San Diego County</p>
        </div>

        <div className="relative">
          {/* Testimonials Slider */}
          <div className="overflow-hidden">
            <div 
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentSlide * (100 / 3)}%)` }}
            >
              {testimonials.map((testimonial, index) => (
                <div key={index} className="w-1/3 flex-shrink-0 px-4">
                  <div className="bg-white rounded-lg shadow-lg p-6 h-full">
                    <div className="flex items-center mb-4">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <i key={i} className="fas fa-star text-yellow-400 text-sm mr-1"></i>
                      ))}
                    </div>
                    
                    <p className="text-gray-700 mb-6 leading-relaxed">"{testimonial.text}"</p>
                    
                    <div className="flex items-center">
                      <img 
                        src={testimonial.avatar} 
                        alt={testimonial.name}
                        className="w-12 h-12 rounded-full mr-4 object-cover"
                        onError={(e) => {
                          e.currentTarget.src = "https://www.canadacleanhome.com/wp-content/plugins/business-reviews-bundle/assets/img/google_avatar.png";
                        }}
                      />
                      <div>
                        <div className="font-semibold text-gray-900">{testimonial.name}</div>
                        <div className="text-sm text-gray-500">{testimonial.timeAgo}</div>
                      </div>
                    </div>
                    
                    <div className="mt-4 flex items-center">
                      <i className="fab fa-google text-blue-500 mr-2"></i>
                      <span className="text-sm text-gray-600">Google Review</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Buttons */}
          <button 
            onClick={prevSlide}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-4 bg-white rounded-full p-3 shadow-lg hover:shadow-xl transition-shadow cursor-pointer"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-arrow-left-line text-xl text-gray-600"></i>
            </div>
          </button>
          
          <button 
            onClick={nextSlide}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-4 bg-white rounded-full p-3 shadow-lg hover:shadow-xl transition-shadow cursor-pointer"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xl text-gray-600"></i>
            </div>
          </button>

          {/* Pagination Dots */}
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
                  index === currentSlide ? 'bg-teal-600' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
